import endpoint from 'utils/endpoint';

import { doctorProfileRoute } from 'lib/apiRoutes';

import { FETCH_DOCTOR_PROFILE } from './types';

// eslint-disable-next-line import/prefer-default-export
export const fetchDoctorProfileEndpoint = (slug) => endpoint(FETCH_DOCTOR_PROFILE, 'GET', doctorProfileRoute(slug));
